import {useEffect, useState} from 'react';

export const useNetInfoProvider = ({isConnected}: any) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (isConnected) {
      setIsVisible(true);
    }
  }, [isConnected]);

  const onClose = () => {
    setIsVisible(false);
  };

  return {
    onClose,
    isVisible,
  };
};
